<template>
  <footer class="footer text-white">
    <div class="container-fluid">
      <div class="row">
        <!--INFOPAGES LINKS HERE-->
        <div class="col-12 col-md-6 col-lg-4">
          <h4 v-text="this.title" />
          <ul class="footer__nav-items">
            <li v-for="(item, index) in navItems" :key="index">
              <a v-if="item.external && item.url" :href="item.url" target="_blank" v-text="item.title"/>
              <router-link v-if="!item.external && item.url" :to="`/${$i18n.locale}/${item.url}`">
                {{ item.title }}
              </router-link>
            </li>
          </ul>
        </div>
        <!--SOCIAL HERE-->
        <div class="col-12 col-md-6 col-lg-4" >
          <h4 v-text="$t('footer.followUs')" />
          <ul class="footer__nav-items footer__social-items">
            <li v-for="(item, index) in socialItems" :key="index">
              <a :href="item.link.url" target="_blank">
                {{ item.name }}
                <svg width="32" height="32" viewBox="0 0 2902.7 2902.7" xmlns="http://www.w3.org/2000/svg">
                  <rect width="2902.7" height="2902.7" :mask="'url(#icon-' + item.name.toLowerCase() + ')'"></rect>
                </svg>
              </a>
            </li>
          </ul>
        </div>
        <!--PREMIUM PARTNER HERE-->
        <div class="col-12 col-lg-4">
          <h4 v-if="raceSeries === this.dtm" v-text="$t('footer.premiumManufacturers')" />
          <h4 v-if="raceSeries === this.dtmTrophy" v-text="$t('footerTrophy.premiumManufacturers')" />
          <div class="row">
            <div v-for="(item, index) in manufacturers" :key="index" :class="{ 'col-6': manufacturers.length <= 2, 'col-4': manufacturers.length > 2 }">
              <img class="footer__manufacturer-item" width="100%"
                :alt="item.imageAlt"
                :title="item.imageTitle"
                :src="item.image ? item.image.url : pixel"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import AppConst from '../config/app.const';
import Settings from '../config/settings';

export default {
  name: 'Footer',
  data () {
    return {
      title: null,
      navItems: [],
      socialItems: [],
      manufacturers: [],
      pixel: AppConst.PIXEL,
      dtm: AppConst.DTM,
      dtmTrophy: AppConst.DTM_TROPHY
    };
  },
  computed: {
    queryNameManufacturers: function () {
      return this.$store.getters['page/raceSeriesManufacturer'];
    },
    raceSeries: function () {
      return this.$store.getters['page/raceSeries'];
    },
    queryNameFooter: function () {
      return this.$store.getters['page/raceSeriesFooter'];
    },
    queryParamSocialChannels: function () {
      return this.$store.getters['page/raceSeries'] === 'dtm' ? 'DTM' : 'DTMTrophy';
    }
  },
  methods: {
    async fetchFooterNavigation () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: `data?query=${this.queryNameFooter}`,
        lifetime: Settings.LIFETIME_STATIC
      })
        .then(response => {
          response.navigations.forEach(navigation => {
            this.title = navigation.title;
            this.navItems = navigation.navItems;
          });
        })
        .catch(() => {
          setTimeout(this.fetchFooterNavigation, 3000);
        });
    },
    async fetchFooterSocial () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: `data?query=socialChannels&raceSeries=${this.queryParamSocialChannels}`,
        lifetime: Settings.LIFETIME_STATIC
      })
        .then(response => {
          this.socialItems = response.socialchannels;
        })
        .catch(() => {
          setTimeout(this.fetchFooterSocial, 3000);
        });
    },
    async fetchManufacturers () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: `data?query=${this.queryNameManufacturers}`,
        lifetime: Settings.LIFETIME_STATIC
      })
        .then(response => {
          this.manufacturers = response.manufacturers ? response.manufacturers : response.manufacturerTrophies ? response.manufacturerTrophies : [];
        })
        .catch(() => {
          setTimeout(this.fetchManufacturers, 3000);
        });
    }
  },
  watch: {
    $route () {
      this.fetchFooterNavigation();
      this.fetchFooterSocial();
      this.fetchManufacturers();
    }
  },
  created () {
    // fetch the navigation items
    this.fetchFooterNavigation();
    this.fetchFooterSocial();
    this.fetchManufacturers();
  }
};
</script>

<style lang="scss">
  .footer {
    background-color: $color-bg-med;
    overflow: hidden;
    width: 100%;

    h4 {
      margin-top: 55px;
      text-transform: uppercase;
      font-style: italic;
      font-size: 20px;
    }

    &__nav-items {
      padding: 0;
      list-style-type: none;
      a {
        display: inline-block;
        position: relative;
        font-family: var(--font-condensed);
        text-transform: uppercase;
        font-weight: 600;
        font-style: italic;
        padding: $gap / 2 0;
        letter-spacing: 0.25px;
        transition: letter-spacing .4s linear;
        &:hover {
          letter-spacing: 0.5px;
        }
      }
    }

    &__social-items {
      svg {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0, -54%);
        rect {
          fill: #fff;
          transition: all .3s;
        }
      }
      a {
        padding: $gap 0 $gap 32px + $gap;
        &:hover {
          svg rect {
            fill: $color-primary;
          }
        }
      }
    }

    &__manufacturer-item {
      max-width: 200px;
      height: auto;
    }
  }
</style>
